




import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Chart } from "chart.js";
import { ChartOptions } from "./graphData";
import "chartjs-plugin-datalabels";
@Component
export default class Doughnut extends Vue {
  @Prop({ default: [] }) public readonly labels!: Array<string>;
  @Prop({ default: [] }) public colors!: Array<string>;
  @Prop({ default: [] }) public readonly data!: Array<number>;
  @Prop({
    default: () => {
      return Chart.defaults.doughnut;
    },
  })
  @Prop()
  public readonly id!: string;

  @Prop({ default: () => new ChartOptions() })
  public readonly options!: ChartOptions;
  public chart: any;

  public mounted() {
    // console.log(ChartLabels);
    if (null !== this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }

  public makeChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.createChart({
      datasets: [
        {
          data: this.data,
          defaultColor: "transparent",
          pointBackgroundColor: "transparent",
          pointBorderColor: "transparent",
          backgroundColor: this.colors,
          borderColor: "transparent",
          borderWidth: 1,
        },
      ],
      labels: this.labels,
    });
  }

  public createChart(chartData: object) {
    const canvas = document.getElementById(this.id) as HTMLCanvasElement;

    // Pour Chart.js v2.8.0, la structure est différente
    // Les plugins sont configurés directement dans les options, pas dans un objet plugins
    const options = {
      type: "doughnut",
      data: chartData,
      options: {
        // Commencer par les options de base
        ...this.options,
        // Puis configurer les plugins spécifiquement pour ce composant
        plugins: {
          datalabels: {
            display: (context: any) => {
              return context.dataset.data[context.dataIndex] !== 0;
            },
            anchor: "center",
            align: (context: any) => {
              const dataset = context.chart.data.datasets[0];
              const index = context.dataIndex;
              const total = dataset.data.reduce(
                (a: number, b: number) => a + b,
                0
              );
              const percentage = (dataset.data[index] / total) * 100;
              return percentage < 5
                ? index % 2 === 0
                  ? "end"
                  : "start"
                : "center";
            },
            offset: (context: any) => {
              const dataset = context.chart.data.datasets[0];
              const index = context.dataIndex;
              const total = dataset.data.reduce(
                (a: number, b: number) => a + b,
                0
              );
              const percentage = (dataset.data[index] / total) * 100;
              return percentage < 5 ? -1 : 0;
            },
            formatter: (value: any) => {
              return `${value.toFixed(2)} €`;
            },
            color: "#FFFFFF",
            font: {
              size: 12,
              weight: "bold",
            },
            clip: true,
            // Fusionner avec les options existantes des plugins si elles existent
            ...(this.options.plugins && this.options.plugins.datalabels ? this.options.plugins.datalabels : {}),
          },
          // Ajouter les autres plugins des options si ils existent
          ...(this.options.plugins || {}),
        },
      },
    };

    this.chart = new Chart(canvas, options);
  }

  @Watch("labels", { immediate: false })
  public onPropertyChangedLabel(value: any, oldValue: any) {
    if (null !== this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }

  @Watch("data", { immediate: false, deep: true })
  public onPropertyChangedData(value: any, oldValue: any) {
    if (null !== this.data && this.data.length > 0) {
      this.makeChart();
    }
  }

  @Watch("options", { immediate: false, deep: true })
  public onPropertyChangedOptions(value: any, oldValue: any) {
    if (this.data && this.data.length > 0 && this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }
}
